import { useTranslation } from 'react-i18next';
import { Row } from '../../components/Grid/Grid';
import Icon from '../../components/Icon/Icon';
import Text from '../../components/Text/Text';
import Panel from '../../components/Panel/Panel';
import { Spaced } from '../../components/Spaced/Spaced';
import { useStyles } from './styles';
import AppFooterLoading from './AppFooterLoading';

function AppFooter() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Panel loadingComponent={<AppFooterLoading />}>
      <Spaced>
        <Row justifyContent="space-between">
          <Row>
            <Icon name="lock" className={classes.lockIcon} />
            <Text type="secondaryMedium">{t('safePurchase')}</Text>
          </Row>
          <Icon name="appLogo" className={classes.appLogo} />
        </Row>
      </Spaced>
    </Panel>
  );
}

export default AppFooter;
